export let MFAStep;
(function (MFAStep) {
  MFAStep["verify"] = "verify";
  MFAStep["recoveryCode"] = "recoveryCode";
  MFAStep["authenticatorApp"] = "authenticatorApp";
  MFAStep["smsSetPhoneNumber"] = "smsSetPhoneNumber";
  MFAStep["smsVerifyCode"] = "smsVerifyCode";
  MFAStep["emailVerifyCode"] = "emailVerifyCode";
  MFAStep["noMFAEnrolledStepUp"] = "noMFAEnrolledStepUp";
})(MFAStep || (MFAStep = {}));